import React, { useState } from "react";
import data from "../data/contact.json";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";

const Contact = ({ isBg }) => {
  const { contact } = data;
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [isPending, setIsPending] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  const [isError, setIsError] = useState("");
  const recaptchaRef = React.createRef();

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsPending(true);
    setIsError(false);
    setIsSuccess(false);

    const contactFormData = new FormData();
    contactFormData.append('name', name);
    contactFormData.append('email', email);
    contactFormData.append('subject', subject);
    contactFormData.append('message', message);
    contactFormData.append('recaptcha', recaptchaRef.current.getValue());

    axios
      .post("https://jutefoster.com/api/mail", contactFormData)
      .then((response) => {
        setIsPending(false);
        setIsSuccess(true);
        setName("");
        setEmail("");
        setSubject("");
        setMessage("");
      })
      .catch((err) => {
        setIsPending(false);
        setIsError(true);
      });

    recaptchaRef.current.reset();
  };

  return (
    // <!-- ========== Contact section start ========== -->
    <section
      id="contact"
      className={`p-80px-tb ${isBg === "yes" ? "bg-one" : ""}`}
    >
      <div className="container">
        <div className="row">
          <div className="col-xl-6 offset-xl-3 col-lg-10 offset-lg-1">
            <div className="section-title-center text-center">
              <span>{contact.subtitle}</span>
              <h2 className="display-6">{contact.title}</h2>
              <div className="section-divider divider-traingle"></div>
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          {/* <!--  contact form area start --> */}
          <div
            className="col-lg-8"
            data-aos="fade-right"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <div className="contact-form-box">
              <form
                id="contact-form"
                onSubmit={handleSubmit}
              >
                <div className="message col">
                  {isPending && (<p className="email-loading alert alert-warning">
                    <img src="assets/images/loading.gif" alt="loader" />
                    &nbsp;&nbsp;&nbsp;Sending...
                  </p>)}
                  {isSuccess && (<p className="email-success alert alert-success">
                    <i className="icofont-check-circled"></i> Your message has been sent.
                  </p>)}
                  {isError && (<p className="email-failed alert alert-danger">
                    <i className="icofont-close-circled"></i> Something went wrong!
                  </p>)}
                </div>
                <div className="mb13">
                  <input
                    name="name"
                    className="contact-name"
                    id="contact-name"
                    type="text"
                    value={name}
                    placeholder="Your Name"
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>
                <div className="mb13">
                  <input
                    name="email"
                    className="contact-email"
                    id="contact-email"
                    type="email"
                    value={email}
                    placeholder="Your Email"
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <div className="mb13">
                  <input
                    name="subject"
                    className="contact-subject"
                    id="contact-subject"
                    type="text"
                    value={subject}
                    placeholder="Subject"
                    onChange={(e) => setSubject(e.target.value)}
                    required
                  />
                </div>
                <div className="mb30">
                  <textarea
                    name="message"
                    className="contact-message"
                    id="contact-message"
                    placeholder="Your Message"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                  ></textarea>
                </div>
                <div className="contact__recaptcha">
                  <ReCAPTCHA ref={recaptchaRef} sitekey={process.env.REACT_APP_SITE_KEY} />
                </div>
                <button
                  type="submit"
                  className={`button align-items-center ${isPending ? "contact__button-disabled" : "button__primary"}`}
                  disabled={isPending}
                >
                  <span>{contact.btnText}</span>
                </button>
              </form>
            </div>
          </div>
          {/* <!--  contact form area end --> */}
        </div>
      </div>
    </section>
    // <!-- ========== Contact section end ========== -->
  );
};

export default Contact;
